/* eslint-disable tailwindcss/no-arbitrary-value */
import SeedlyIcon from '@hyphengroup/cms-components/components/icons/SeedlyIcon';
import Tooltip from '@hyphengroup/cms-components/components/Tooltip';

interface MiniProductHighlightRatingProps {
  score: string | number;
  info?: string;
  max?: number;
}

export const MiniProductHighlightRating: React.FC<
  MiniProductHighlightRatingProps
> = ({ score, info = '', max = 5 }) => {
  return (
    <div className="flex items-center gap-spacing/gap/soft-4px">
      <div className="flex items-center gap-spacing/gap/soft-6px">
        <SeedlyIcon className="h-[18px] w-[58px]" />
        <span className="mhg-alpha-typography-body-2 text-text/secondary">
          rating
        </span>
      </div>
      <div className="flex items-center gap-spacing/gap/soft-6px">
        <span className="mhg-alpha-typography-bullet-2 text-[#2955DE]">
          {score}
        </span>
        <span className="mhg-alpha-typography-body-2 text-text/secondary">
          / {max}
        </span>
        {info && (
          <Tooltip
            infoClass="!size-[--shapes-icon-size-sm] text-text/disabled"
            content={info}
          />
        )}
      </div>
    </div>
  );
};
